<template>
  <div class="select-5 flex-center">
    <div class="select-title">
      <p>多样化活动</p>
      <p>丰富H5变现内容</p>
    </div>
    <div class="list">
      <ul>
        <li class="flex-v-center">
          <div>
            <img src="../images/a-04.png" alt />
          </div>
        </li>
        <li class="flex-v-center">
          <div>
            <img src="../images/a-05.png" alt />
          </div>
        </li>
        <li class="flex-v-center">
          <div>
            <img src="../images/a-06.png" alt />
          </div>
        </li>
      </ul>
       <div class="paginations">
      <!-- <span class="pag-pre">
        <img src="../images/pre.png" alt="">
      </span>
      <span class="pag-next">
        <img src="../images/next.png" alt="">
      </span> -->
    </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "selectFive"
  };
</script>

<style lang="scss" scoped>
  .select-5 {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    padding-bottom: 52px;

    .select-title {
      margin-top: 47px;

      p:nth-child(1) {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(50, 50, 50, 1);
        margin-bottom: 8px;
      }

      p:nth-child(2) {
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-bottom: 44px;
      }
    }

    .list {
      position: relative;
      li {
        display: inline-block;
        text-align: center;
        margin: 9px;

        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(50, 50, 50, 1);
          margin-bottom: 10px;
          text-align: center;
        }

        div {
          position: relative;
          width: 359px;
            height: 464px;
          box-sizing: border-box;
          background: #ffffff;
          overflow: hidden;


          img {
            width: 359px;
            height: 464px;
          }
        }
      }
      .paginations{
        .pag-pre{
          position: absolute;
          left: -70px;
          top: 240px;
        }
        .pag-next{
          position: absolute;
          right: -70px;
          top: 240px;
        }
      }
    }
  }
</style>